module.exports = __webpack_public_path__ + "static/RootSans-3Light-bf9d5bfc98977b237d05dfd7a65eaa63.woff2";